import { useElementShown } from '@hh.ru/analytics-js';
import authorizeDynamicChartButtonClick from '@hh.ru/analytics-js-events/build/career_platform/authorization/authorize_dynamic_chart_button_click';
import salaryVacancyButtonClick from '@hh.ru/analytics-js-events/build/career_platform/profession/salary_vacancy_button_click';
import salaryVacancyElementShown from '@hh.ru/analytics-js-events/build/career_platform/profession/salary_vacancy_element_shown';
import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Button } from '@hh.ru/magritte-ui';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';
import { SPALink } from '@hh.ru/redux-spa-middleware';

import { LOGIN_ROUTE } from 'src/app/routesUtils';
import LockedContent from 'src/components/BlurryCardContent/LockedContent/LockedContent';
import AreaChart from 'src/pages/Profession/components/SectionStatistics/AreaChart';

const TrlKeys = {
    title: 'career-platform.profession.sections.statistic.chart.salary.title',
    description: 'career-platform.profession.sections.statistic.chart.salary.description',
    lockedContent: {
        title: 'career-platform.profession.sections.statistic.chart.salary.lock.title',
        description: 'career-platform.profession.sections.statistic.chart.salary.lock.description',
        login: 'career-platform.profession.sections.statistic.chart.salary.lock.login',
    },
};

const SalariesChart: TranslatedComponent = ({ trls }) => {
    const { values, initValue } = useSelectorNonNullable((state) => state.pageProfession.statistic.salary);
    const blurred = useSelectorNonNullable((state) => state.pageProfession.statistic.blurred);
    const currentGrade = useSelectorNonNullable((state) => state.pageProfession.currentGrade);
    const professionId = useSelectorNonNullable((state) => state.pageProfession.professionId);

    const handleClick = () => {
        if (currentGrade) {
            authorizeDynamicChartButtonClick({
                buttonName: 'salary_dynamics',
                levelId: currentGrade.id,
                professionId,
            });
        }
    };

    const ref = useElementShown(salaryVacancyElementShown, {
        professionId,
        levelId: currentGrade?.id!, // eslint-disable-line @typescript-eslint/no-non-null-asserted-optional-chain
        isBlur: blurred,
    });

    if (!initValue) {
        return null;
    }

    return (
        <AreaChart
            ref={ref}
            title={trls[TrlKeys.title]}
            description={trls[TrlKeys.description]}
            data={values}
            initValue={initValue}
            onChartClick={() => salaryVacancyButtonClick({ buttonName: 'salaries' })}
            data-qa="section-statistics-salaries-chart"
            blurred={blurred}
            aboveContent={
                <LockedContent
                    title={trls[TrlKeys.lockedContent.title]}
                    description={trls[TrlKeys.lockedContent.description]}
                    action={
                        <Button
                            Element={SPALink}
                            to={LOGIN_ROUTE}
                            isSeoLink
                            onClick={handleClick}
                            style="accent"
                            size="small"
                            mode="secondary"
                            stretched
                        >
                            {trls[TrlKeys.lockedContent.login]}
                        </Button>
                    }
                />
            }
        />
    );
};

export default translation(SalariesChart);
